import { render } from "./Home.vue?vue&type=template&id=60151ec2"
const script = {}

import exportComponent from "H:\\Projects\\Jesta\\Front\\Jesta-Group\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__